import script from "./tabbar.vue?vue&type=script&setup=true&lang=js"
export * from "./tabbar.vue?vue&type=script&setup=true&lang=js"

import "./tabbar.vue?vue&type=style&index=0&id=6fbe8ace&lang=less&scoped=true"

import exportComponent from "/usr/share/nginx/html/vue_saas/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fbe8ace"]])

export default __exports__